/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetCareerHubTopicPageQueryVariables = Types.Exact<{
  topicKey: Types.Scalars['String']['input'];
}>;

export type GetCareerHubTopicPageQuery = {
  __typename?: 'Query';
  careerHubTopicPage?: {
    __typename?: 'CareerHubTopicPageResponse';
    evergreenArticleUrn: string;
    evergreenTitle: string;
    introduction: Array<string>;
    title: string;
    articles: Array<{
      __typename: 'CareerHubArticle';
      id: string;
      urn: string;
      url: string;
      title: string;
      description: string;
      actorUrn: string;
      pageUrl: string;
      pageTitle: string;
      image: { __typename?: 'CareerHubArticleImage'; srcWide?: string | null };
      pageLogos: {
        __typename?: 'CareerHubArticlePageLogo';
        square48?: string | null;
      };
    } | null>;
  } | null;
};

export const GetCareerHubTopicPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCareerHubTopicPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'topicKey' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careerHubTopicPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'topicKey' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'topicKey' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evergreenArticleUrn' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evergreenTitle' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CareerHubArticleFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareerHubArticleFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareerHubArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'srcWide' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'actorUrn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLogos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'square48' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCareerHubTopicPageQuery,
  GetCareerHubTopicPageQueryVariables
>;
